export const getPosition = `
  bool shouldHideGround() {
    return hideGround && instanceId == GROUND_INSTANCE_ID;
  }

  vec4 getPosition() {
   if(shouldHideGround()){
      // outside of clip space
      // https://carmencincotti.com/2022-05-02/homogeneous-coordinates-clip-space-ndc/#clip-space
      return vec4(-2.0, -2.0, -2.0, 1);
    }

    if(isViewBoxHighlightEnabled()) {
      // only the main point cloud is rendered using ROI, which will always use
      // pinhole
      return projectionMatrix * modelViewMatrix * vec4(vec3(position), 1.0);
    }

    return getProjection(projectionMatrix, viewMatrix);
  }
`;
